import React from 'react';
import cn from 'classnames';
export default function PaymentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: cn('icons', className),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10.0505H2.87024C3.84523 10.0505 4.70617 10.3486 4.70617 11.4953C4.70617 12.6426 3.84523 12.9407 2.87024 12.9407H2V10.0505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63779 12.4852H2.99295C3.526 12.4852 4.04046 12.1247 4.04046 11.4953C4.04046 10.8659 3.526 10.5059 2.99295 10.5059H2.63779V12.4852V12.4852Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96091 10.0504H5.59871V12.9407H4.96091V10.0504ZM7.65468 10.8134C7.43526 10.6914 7.19911 10.5622 6.94932 10.5341C6.7206 10.5081 6.47701 10.5694 6.47701 10.8581C6.47701 11.3595 7.871 11.148 7.871 12.1169C7.871 12.7502 7.31563 13.0544 6.67721 12.9909C6.33135 12.9561 6.13114 12.8628 5.85532 12.6972V12.1109C6.07412 12.2185 6.39457 12.4178 6.64126 12.4576C6.91213 12.5007 7.20592 12.4234 7.20592 12.1622C7.20592 11.6112 5.81193 11.8392 5.81193 10.883C5.81193 10.237 6.36358 10.0007 6.92328 10.0007C7.19663 10.0007 7.44146 10.094 7.65468 10.2597V10.8134ZM12.2278 10.0007C13.2257 10.0007 13.8728 10.6136 13.8728 11.4875C13.8728 12.361 13.2344 12.9909 12.2278 12.9909C11.2075 12.9909 10.5536 12.3737 10.5536 11.4875C10.5536 10.6009 11.2168 10.0007 12.2278 10.0007ZM13.6577 10.0504H14.3408L15.0492 11.5775L15.7106 10.0504H16.3726L15.1273 12.9407H14.8961L13.6577 10.0504ZM16.5387 10.0504H18.4155V10.5059H17.1765V11.2181H18.3108V11.6736H17.1765V12.4852H18.4248V12.9407H16.5387V10.0504ZM18.5946 10.0504H19.2827C19.9663 10.0504 20.7814 10.0294 20.7814 10.8328C20.7814 11.1723 20.531 11.4539 20.125 11.5036V11.5118C20.2979 11.524 20.3983 11.6819 20.4622 11.81L20.9723 12.9401H20.262L19.8795 12.038C19.7884 11.8227 19.7066 11.7399 19.4376 11.7399H19.2324V12.9407H18.5946V10.0504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2325 11.2844H19.442C19.7562 11.2844 20.1164 11.243 20.1164 10.8825C20.1164 10.5347 19.7612 10.5054 19.442 10.5054H19.2325V11.2844Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7205 10.5368C21.8749 10.5368 22 10.4254 22 10.2878C22 10.1503 21.8749 10.0388 21.7205 10.0388C21.5661 10.0388 21.4409 10.1503 21.4409 10.2878C21.4409 10.4254 21.5661 10.5368 21.7205 10.5368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9318 10.2878C21.9318 10.1714 21.8376 10.0869 21.7204 10.0869C21.6033 10.0869 21.5091 10.1708 21.5091 10.2878C21.5091 10.4043 21.6033 10.4883 21.7204 10.4883C21.837 10.4883 21.9318 10.4038 21.9318 10.2878Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6126 10.1454H21.7304C21.8066 10.1454 21.8469 10.1686 21.8469 10.2282C21.8469 10.2762 21.8159 10.3 21.7645 10.3038L21.8494 10.4275H21.7893L21.7068 10.306H21.6709V10.4275H21.612V10.1454H21.6126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6715 10.2663H21.7236C21.7583 10.2663 21.7886 10.2619 21.7886 10.2244C21.7886 10.1907 21.7546 10.1857 21.7242 10.1857H21.6715V10.2663Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3925 12.652C10.2375 12.8308 9.85074 12.9407 9.58979 12.9573C8.60116 13.0191 7.93671 12.525 7.93671 11.5478C7.93671 10.5584 8.51563 9.98475 9.59413 10.0295C9.80363 10.0383 10.1464 10.1012 10.3782 10.2702V10.8278C10.108 10.6776 9.82781 10.5711 9.59041 10.5623C8.93463 10.5385 8.60178 10.9145 8.60178 11.5064C8.60178 12.0943 8.91232 12.4251 9.59103 12.4024C9.85136 12.3936 10.2511 12.2031 10.3919 12.0982V12.652H10.3925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 11.5007C13.875 12.4874 13.1288 13.0015 12.2083 13.0015C11.2878 13.0015 10.5417 12.4173 10.5417 11.5007C10.5417 10.6409 11.1369 10 12.2083 10C13.1288 10 13.875 10.514 13.875 11.5007Z",
    fill: "#FF971D"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "3",
    fill: "white",
    transform: "translate(2 10)"
  })))));
}